/**
 * @generated SignedSource<<dfef4a940cb785078dd5c3e90b62ef4d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useStarredItemsPaged$data = {
  readonly jira: {
    readonly starredItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "JiraBoard";
          readonly boardId: AGG$Long | null;
          readonly boardTitle: string | null;
          readonly boardUrl?: AGG$URL | null;
          readonly defaultNavigationItem?: {
            readonly url?: string | null;
          } | null;
          readonly id: string;
          readonly lastViewedTimestamp: AGG$Long | null;
        } | {
          readonly __typename: "JiraCustomFilter";
          readonly filterId: string;
          readonly filterTitle: string;
          readonly filterUrl: AGG$URL | null;
          readonly id: string;
          readonly lastViewedTimestamp: AGG$Long | null;
        } | {
          readonly __typename: "JiraDashboard";
          readonly dashboardId: AGG$Long | null;
          readonly dashboardTitle: string | null;
          readonly dashboardUrl: AGG$URL | null;
          readonly id: string;
          readonly lastViewedTimestamp: AGG$Long | null;
        } | {
          readonly __typename: "JiraPlan";
          readonly id: string;
          readonly lastViewedTimestamp: AGG$Long | null;
          readonly planId: AGG$Long | null;
          readonly planTitle: string | null;
          readonly scenario: {
            readonly scenarioId: AGG$Long | null;
          } | null;
        } | {
          readonly __typename: "JiraProductDiscoveryCollection";
          readonly collectionId?: AGG$Long | null;
          readonly collectionTitle?: string | null;
          readonly collectionUrl?: AGG$URL | null;
          readonly emoji?: string | null;
          readonly id?: string;
          readonly lastViewedTimestamp?: AGG$Long | null;
        } | {
          readonly __typename: "JiraProject";
          readonly avatar: {
            readonly large: string | null;
          } | null;
          readonly defaultNavigationItem: {
            readonly url?: string | null;
          } | null;
          readonly description: string | null;
          readonly id: string;
          readonly key: string;
          readonly lastViewedTimestamp: AGG$Long | null;
          readonly projectId: string | null;
          readonly projectTitle: string;
        } | {
          readonly __typename: "JiraServiceManagementQueue";
          readonly id: string;
          readonly lastViewedTimestamp: AGG$Long | null;
          readonly queueId: AGG$Long | null;
          readonly queueTitle: string | null;
          readonly queueUrl: AGG$URL | null;
        } | {
          readonly __typename: "JiraSystemFilter";
          readonly filterId: string;
          readonly filterTitle: string;
          readonly filterUrl: AGG$URL | null;
          readonly id: string;
          readonly lastViewedTimestamp: AGG$Long | null;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null;
      } | null> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      };
    } | null;
  };
  readonly " $fragmentType": "useStarredItemsPaged";
};
export type useStarredItemsPaged$key = {
  readonly " $data"?: useStarredItemsPaged$data;
  readonly " $fragmentSpreads": FragmentRefs<"useStarredItemsPaged">;
};

import useStarredItemsPaginationQuery_graphql from './useStarredItemsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "jira",
  "starredItems"
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "lastViewedTimestamp"
},
v3 = {
  "kind": "LinkedField",
  "name": "defaultNavigationItem",
  "plural": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "url"
        }
      ],
      "type": "JiraNavigationItem",
      "abstractKey": "__isJiraNavigationItem"
    }
  ]
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "alias": "filterTitle",
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "kind": "ScalarField",
    "name": "filterUrl"
  },
  {
    "kind": "ScalarField",
    "name": "filterId"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisGsnBoardUrlFixEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "filter"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": useStarredItemsPaginationQuery_graphql
    }
  },
  "name": "useStarredItemsPaged",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "starredItems",
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              {
                "kind": "Variable",
                "name": "filter",
                "variableName": "filter"
              }
            ],
            "concreteType": "JiraFavouriteConnection",
            "kind": "LinkedField",
            "name": "__useStarredItemsPaged_starredItems_connection",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraFavouriteEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": "projectTitle",
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          (v3/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "large"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "projectId"
                          }
                        ],
                        "type": "JiraProject"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "planId"
                          },
                          {
                            "concreteType": "JiraScenario",
                            "kind": "LinkedField",
                            "name": "scenario",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "scenarioId"
                              }
                            ]
                          },
                          {
                            "alias": "planTitle",
                            "kind": "ScalarField",
                            "name": "title"
                          }
                        ],
                        "type": "JiraPlan"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": "boardTitle",
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisGsnBoardUrlFixEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "boardUrl"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "boardId"
                          },
                          {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisGsnBoardUrlFixEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              (v3/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraBoard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": "dashboardTitle",
                            "kind": "ScalarField",
                            "name": "title"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "dashboardUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                          }
                        ],
                        "type": "JiraDashboard"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v4/*: any*/),
                        "type": "JiraSystemFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v4/*: any*/),
                        "type": "JiraCustomFilter"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          {
                            "alias": "queueTitle",
                            "kind": "ScalarField",
                            "name": "title"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "queueUrl"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "queueId"
                          }
                        ],
                        "type": "JiraServiceManagementQueue"
                      },
                      {
                        "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcisJpdRoadmapsRecentsEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v1/*: any*/),
                              (v2/*: any*/),
                              {
                                "alias": "collectionTitle",
                                "kind": "ScalarField",
                                "name": "title"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "collectionUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "collectionId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "emoji"
                              }
                            ],
                            "type": "JiraProductDiscoveryCollection"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              }
            ]
          }
        ]
      },
      "action": "THROW"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "1c843065fe77bd8946ddb3f11f052f8e";

export default node;
